import { COUNTRY_CODE, REGIONS } from "../constants";
import { CONTENT_TYPE, PLAYER_TYPE, State } from "../enums";
import { OnDemand, ScheduledProgram } from "../types/player-api";

export const isLivePlayer = (playerType: PLAYER_TYPE): boolean =>
  [PLAYER_TYPE.WEBCAST, PLAYER_TYPE.CHANNEL].includes(playerType);

export const resolvePlayerType = (state: State, serviceId?: string) =>
  state === State.ONGOING_ONDEMAND ||
  state === State.SRC_AUDIO ||
  state === State.NOT_ALLOWED
    ? PLAYER_TYPE.ONDEMAND
    : state === State.ONGOING_EVENT && serviceId === "yle-areena"
      ? PLAYER_TYPE.WEBCAST
      : PLAYER_TYPE.CHANNEL;

export const isFakeOndemand = (
  state: State,
  serviceSchedule?: ScheduledProgram[]
) => state === State.ONGOING_ONDEMAND && serviceSchedule?.length === 1;

export const isChannelPlayer = (playerType: PLAYER_TYPE): boolean =>
  playerType === PLAYER_TYPE.CHANNEL;

export const localizedText = (obj, lang = "fin") =>
  (obj && (obj[lang] || obj.fin)) || "";

export const isOnDemandViewable = (
  countryCode: string,
  nextOnDemand?: OnDemand
) =>
  nextOnDemand
    ? countryCode === COUNTRY_CODE.FI || nextOnDemand.region !== REGIONS.FINLAND
    : false;

export const isAudio = (type?: CONTENT_TYPE) =>
  type === CONTENT_TYPE.AUDIO_OBJECT;

const END_OFFSET = 35;

export const isContinuingPlayback = (
  durationInSeconds?: number,
  playedDuration?: number,
  seek?: number
): boolean =>
  typeof playedDuration === "number" &&
  playedDuration > 0 &&
  durationInSeconds !== undefined &&
  durationInSeconds - playedDuration > END_OFFSET &&
  !seek;

export const getStartTime = (
  seek: number | undefined,
  isContinuingWatching: boolean,
  watchedDuration: number | undefined
) => seek || (isContinuingWatching && watchedDuration) || -1;
